/**
 * ViiTor Translate — AI translation & bilingual subtitles
 *
 * Declares a single web-accessible-resource group matched to every origin with no
 * `use_dynamic_url`, globbing `images/*` — the extension's only exposed surface. The
 * bundled icons and logos all resolve from any page at a fixed URL.
 *
 * With only images exposed, both signals are images: they load through `probeImage`
 * with no CORS grant and survive a strict page CSP. The dark logo is the primary signal
 * and the 128px icon corroborates.
 *
 * Manifest verified against version 2.0.16.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'debflmkfmkejgppfabgfcbemelmnpnho';

export const viitorTranslate: ExtensionDefinition = {
  id: ID,
  name: 'ViiTor Translate - AI Translation & Real-Time Bilingual Subtitles & Free',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Only images/* is exposed, on every origin with no dynamic URL. Both probes are ' +
    'images that load without a CORS grant, so detection survives a strict page CSP.',
  signals: [
    {
      id: 'war-logo-dark-png',
      kind: 'web-accessible-resource',
      description:
        'Load images/logo-dark.png via <img> — a bundled logo exposed to every origin; ' +
        'needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/logo-dark.png'),
    },
    {
      id: 'war-icon-128-png',
      kind: 'web-accessible-resource',
      description: 'Load images/icon128.png via <img> — a second image, corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'images/icon128.png'),
    },
  ],
};
